import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

type amlApproveAll = operations["approveAll"];

/**
 * Одобрить все риски
 */
export const amlApproveRiskAll = ({
  requestId,
}: {
  requestId: string;
}): Promise<amlApproveAll["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.amlApproveRiskAll(requestId));
};
